import * as React from 'react';
import { Route, Switch } from 'react-router';
import '@servicetitan/anvil-fonts/dist/css/anvil-fonts.css';
import '@servicetitan/design-system/dist/system.min.css';
import { SignaturePageContainer } from './signature-page/signature-page';
import { ErrorPage } from 'src/core/components/error-page/error-page';
import { PrivateRoute } from 'src/routes';
import { DocumentDetails } from './document-details/document-details';
import { DocumentDownload } from './document-details/document-download/document-download';

export interface RouteParams {
    visitActionId?: string;
    submittingId?: string;
    invoiceId?: string;
    invoiceSignatureId?: string;
    projectId?: string;
    projectSignatureId?: string;
    signatureType?: string;
    disclaimerId?: string;
}

export const SignatureRoutes: React.SFC = () => (
    <Switch>
        <Route
            exact
            path="/signatures/expired-link"
            component={() => <ErrorPage type="expired-link" />}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId"
            component={SignaturePageContainer}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/form-signature/:submittingId"
            component={DocumentDetails}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/form-signature/:submittingId/print"
            component={DocumentDownload}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/invoice-signature/:invoiceId/:signatureType/:disclaimerId"
            component={DocumentDetails}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/invoice-signature/:invoiceId/:signatureType"
            component={DocumentDetails}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/project-signature/:projectId/:signatureType/:disclaimerId"
            component={DocumentDetails}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/project-signature/:projectId/:signatureType"
            component={DocumentDetails}
        />

        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/invoice-signature-request/:invoiceSignatureId"
            component={DocumentDownload}
        />
        <PrivateRoute
            allowAnonVisitAction
            exact
            path="/signatures/:visitActionId/project-signature-request/:projectSignatureId"
            component={DocumentDownload}
        />
        <Route component={() => <ErrorPage type="not-found" />} />
    </Switch>
);
